<template lang="pug">
    a(href="" @click.prevent="direct").event
        .top-content
            img(:src="event.icon.path")

            h4.event-title {{ event.category_name }}


</template>

<script>
    export default {
        name: 'Event',
        props: ['event'],
        methods: {
            direct() {
                if(this.event.type !== 'Individual') {
                    this.$router.push({ name: 'event', params: { 'slug': this.event.slug, 'id': this.event.id } })
                } else {
                    this.$router.push({ name: 'accommodation', params: { 'id': this.event.id } })
                }
                
                window.localStorage.setItem('eventCategoryId', this.event.id)
            }
        },
        created() {
            window.localStorage.removeItem('firstStepBookingId');
        }
    };
</script>


